import { jsx as o } from "react/jsx-runtime";
import { c } from "../../../clsx-OuTLNxxd.js";
const w = "_flex_1unjf_29", d = "_wrap_1unjf_71", h = "_nowrap_1unjf_74", _ = {
  flex: w,
  "flex-row": "_flex-row_1unjf_38",
  "flex-column": "_flex-column_1unjf_41",
  "justify-start": "_justify-start_1unjf_44",
  "justify-end": "_justify-end_1unjf_47",
  "justify-center": "_justify-center_1unjf_50",
  "justify-space-between": "_justify-space-between_1unjf_53",
  "justify-space-around": "_justify-space-around_1unjf_56",
  "align-start": "_align-start_1unjf_59",
  "align-end": "_align-end_1unjf_62",
  "align-center": "_align-center_1unjf_65",
  "align-stretch": "_align-stretch_1unjf_68",
  wrap: d,
  nowrap: h,
  "wrap-reverse": "_wrap-reverse_1unjf_77",
  "is-full-width": "_is-full-width_1unjf_83",
  "is-full-height": "_is-full-height_1unjf_86",
  "gap-0": "_gap-0_1unjf_89",
  "gap-1": "_gap-1_1unjf_92",
  "gap-2": "_gap-2_1unjf_95",
  "gap-3": "_gap-3_1unjf_98",
  "gap-4": "_gap-4_1unjf_101",
  "gap-5": "_gap-5_1unjf_104",
  "gap-6": "_gap-6_1unjf_107",
  "gap-7": "_gap-7_1unjf_110",
  "gap-8": "_gap-8_1unjf_113",
  "gap-9": "_gap-9_1unjf_116",
  "gap-10": "_gap-10_1unjf_119",
  "gap-11": "_gap-11_1unjf_122",
  "gap-12": "_gap-12_1unjf_125",
  "gap-14": "_gap-14_1unjf_128",
  "gap-16": "_gap-16_1unjf_131",
  "gap-18": "_gap-18_1unjf_134",
  "gap-20": "_gap-20_1unjf_137",
  "gap-24": "_gap-24_1unjf_140",
  "gap-28": "_gap-28_1unjf_143",
  "gap-32": "_gap-32_1unjf_146",
  "gap-36": "_gap-36_1unjf_149",
  "gap-40": "_gap-40_1unjf_152",
  "gap-44": "_gap-44_1unjf_155",
  "gap-48": "_gap-48_1unjf_158",
  "gap-52": "_gap-52_1unjf_161",
  "gap-56": "_gap-56_1unjf_164",
  "gap-60": "_gap-60_1unjf_167",
  "gap-64": "_gap-64_1unjf_170",
  "gap-72": "_gap-72_1unjf_173",
  "gap-80": "_gap-80_1unjf_176",
  "gap-96": "_gap-96_1unjf_179",
  "no-margin": "_no-margin_1unjf_182",
  "dialog-overlay-show": "_dialog-overlay-show_1unjf_1",
  "dialog-content-show": "_dialog-content-show_1unjf_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1unjf_1"
};
function m({
  children: n,
  direction: f = "row",
  justifyContent: g = "start",
  alignItems: p = "start",
  flexWrap: u = "wrap",
  className: j = "",
  isFullWidth: e = !1,
  isFullHeight: t = !1,
  gap: a,
  style: s,
  noMargin: l = !1,
  ...i
}) {
  const r = c(
    _.flex,
    _[`flex-${f}`],
    _[`justify-${g}`],
    _[`align-${p}`],
    _[u],
    e && _["is-full-width"],
    t && _["is-full-height"],
    a && _[`gap-${a}`],
    l && _["no-margin"],
    j
  );
  return /* @__PURE__ */ o("div", { className: r, ...i, style: s, children: n });
}
export {
  m as Flex
};
